"use client"

import { usePathname } from "next/navigation"
import type { BlockchainFilter } from "../blockchains/filters/blockchain-filters-scope"
import { LeaderboardPageType } from "./leaderboard-types"

export const getLeaderboardHref = (blockchain: BlockchainFilter) =>
  `/${blockchain.toLowerCase()}`

export const HREF_FACTORY_BY_PAGE_TYPE: Record<
  LeaderboardPageType,
  (blockchain: BlockchainFilter) => string
> = {
  [LeaderboardPageType.TRENDING]: (blockchain) =>
    `${getLeaderboardHref(blockchain)}`,
  [LeaderboardPageType.HOLDING]: (blockchain) =>
    `${getLeaderboardHref(blockchain)}/holding`,
  [LeaderboardPageType.WATCHLIST]: (blockchain) =>
    `${getLeaderboardHref(blockchain)}/watchlist`,
}

export const useLeaderboardPageHref = (
  pageType: LeaderboardPageType,
  blockchain: BlockchainFilter,
) => HREF_FACTORY_BY_PAGE_TYPE[pageType](blockchain)

export const useLeaderboardActiveLinkChecker = (
  pageType: LeaderboardPageType,
  blockchain: BlockchainFilter,
) => {
  const urlPath = usePathname()
  const pathToCheck = useLeaderboardPageHref(pageType, blockchain)

  return urlPath === pathToCheck
}
